import gql from 'graphql-tag';

export default gql`
  mutation putEventWithMe($event: EventType) {
    putEventWithMe(event: $event) @client
  }
`;
